module.exports = __webpack_public_path__ + "img/carte_bleue.8da978b5.svg";